export interface FeedRouter {
  goToList(query?: string): void;
  goToDetail(postId: string, communityId: string): void;
  goToCommunity(id: string, slug: string): void;
  goToCommunities(query?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedRouter = Symbol('FeedRouter');
